import React, { FC } from 'react';

import { AppFormattedMessage } from '../../../components/app-formatted-message/index';
import { Modal } from '../../../components/modal/index';
import { useLocale } from '../../../hooks/index';

export type CancelInvitationProps = {
  isOpen: boolean;
  onDismiss: () => void;
  onSuccess: () => void;
};

const CancelInvitationModal: FC<CancelInvitationProps> = ({ isOpen, onDismiss, onSuccess }) => {
  const { messagesLocale } = useLocale();
  return (
    <Modal
      description={<AppFormattedMessage id="STAKEHOLDER_CANCEL_INVITE_DESCRIPTION" />}
      dismissButtonContent={<AppFormattedMessage id="NO_KEEP_4" />}
      isOpen={isOpen}
      onDismiss={onDismiss}
      onSuccess={onSuccess}
      successButtonContent={messagesLocale['CONFIRM_CANCEL']}
      title={
        <>
          <AppFormattedMessage id="CANCEL_INVITATION" />?
        </>
      }
    />
  );
};

export default CancelInvitationModal;
